
$( function(){

    
      const desc = document.querySelector(".collection-description");
      const btn = document.querySelector(".read-more-btn");
  
      if (desc.scrollHeight > desc.clientHeight) {
        btn.style.display = "inline-block";
        btn.onclick = () => {
          desc.classList.toggle("expanded");
          btn.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";
        };
      }
    
  
	//addSecondImageProduct();

    $('.product-block .product-link').on('click', function(){

        var _this = $(this);
      	var devVname;
        var timer = setInterval(function(){
          if( _this.parent().next('.product-detail').find('.option-selectors').find('ul').length > 0 ){
            devVname = _this.parent().next('.product-detail').find('.option-selectors ul li a.active').attr('data-value');
            
              $(".devVariants li").each(function() {
                var devName = $(this).attr('data-vname');
                var devImage= $(this).attr('data-img');
                
                if( devVname == devName )
                    {
                      $(_this).parent().next('.product-detail').find(".devVariantImg img").attr('src' ,devImage );
                      $(_this).parent().next('.product-detail').find(".devVariantImg img").css("opacity", "1");
                    }
              });
            
            clearInterval(timer);
          }
        }, 1);
        

    });
  
  
   $('.collection-slider .product-link').on('click', function(){
     
        var _this = $(this);
      	var devVname;
        var timer = setInterval(function(){
          if( _this.parents('.collection-slider').parent().next().find('.option-selectors').find('ul').length > 0 ){
            devVname = _this.parents('.collection-slider').parent().next().find('.option-selectors ul li a.active').attr('data-value');
            
            console.log(devVname);
            
              $(".devVariants li").each(function() {
                var devName = $(this).attr('data-vname');
                var devImage= $(this).attr('data-img');
                
                if( devVname == devName )
                    {
                      _this.parents('.collection-slider').parent().next().find(".devVariantImg img").attr('src' ,devImage );
                      _this.parents('.collection-slider').parent().next().find(".devVariantImg img").css("opacity", "1");                    
                    }
              });
            
            clearInterval(timer);
          }
        }, 1);
        

    });

  
});